// @ts-nocheck
import type { SheetStandardFields } from './fields';

export enum SheetType {
  GENERIC = 0,
}

export interface HeaderIndex {
  [key: string]: number[];
}

// Cell type is based on XLSX.ExcelDataType
// b Boolean, n Number, e Error, s String, d Date, z Empty
export type RawCell = boolean | number | string | Error | Date | undefined;

type Content = number | string | null;

export type ParsedCell = Content;

// This typing is too permissive. Check GeofenceTabContainer and pass a number to spreadSheetFields in mapStateToProps
// @ts-ignore
export type Fields<T = SheetStandardFields> = Partial<
  Record<T, Content | Content[]>
>;

export type Cell = string | null | string[];

interface AdditionalInformation {
  [field: string]: string;
}

export type RowWithAdditionalInformation<T> = Fields<T> & {
  additionalInformation: AdditionalInformation;
};

export interface ParsedGenericSheet<T> {
  fields: Fields<T>;
  data: Array<Fields<T>>;
}

export interface ParsedGenericSheets<T> {
  [workbook: string]: ParsedGenericSheet<T>;
}

export interface GenericWorkSheet<T = SheetStandardFields> {
  fields: Fields<T>;
  additionalFields?: Fields<any>;
  data: Array<Fields<T>>;
}

export interface GenericSheet<T = SheetStandardFields> {
  type: SheetType.GENERIC;
  worksheets: Array<GenericWorkSheet<T>>;
}

export type Sheet<T = SheetStandardFields> = GenericSheet<T>;
